(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/arena-react/assets/react/shared/components/menu.js') >= 0) return;  svs.modules.push('/modules/arena-react/assets/react/shared/components/menu.js');

'use strict';

const {
  useHistory,
  useLocation
} = ReactRouterDOM;
const {
  ItemsMenu,
  IconItem,
  LinkItem
} = svs.ui.ReactItemsMenu;
const {
  routes
} = svs.arena.constants;
const Menu = () => {
  const history = useHistory();
  const location = useLocation();
  const moduleBaseUrl = svs.core.data.baseUrl;
  const startUrl = svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER) ? routes.TEAMS : routes.HOME;
  const tabs = [{
    anchor: startUrl,
    anchorAlias: routes.TEAMS_CREATE,
    label: 'Mina lag',
    icon: 'players'
  }, {
    anchor: routes.HISTORY,
    label: 'Historik',
    icon: 'game-history'
  }, {
    anchor: routes.GAMEGUIDE,
    label: 'Spelguide',
    icon: 'spelguide'
  }];
  const isTabActive = tab => tab.anchor === location.pathname || tab.anchorAlias === location.pathname;
  const handleClick = (e, path) => {
    e.preventDefault();
    if (svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER)) {
      history.push(path);
    } else if (path === routes.HOME || path === routes.GAMEGUIDE) {
      history.push(path);
    } else {
      svs.utils.url.navigate(moduleBaseUrl + path);
    }
  };
  if (!tabs.length) {
    return null;
  }
  return React.createElement(ItemsMenu, {
    branding: "neutral",
    centered: true
    ,
    useScrollFaders: true,
    useScrollHelpers: svs.core.detect.formfactor.desktop()
  }, tabs.map(tab => tab.icon ? React.createElement(IconItem, {
    alignment: "vertical",
    Component: "a",
    gutter: 1,
    href: "".concat(moduleBaseUrl).concat(tab.anchor),
    iconName: tab.icon,
    isSelected: isTabActive(tab),
    key: "".concat(tab.anchor, "-").concat(tab.label),
    label: tab.label,
    onClick: e => handleClick(e, tab.anchor)
  }) : React.createElement(LinkItem, {
    alignment: "vertical",
    Component: "a",
    gutter: 1,
    href: "".concat(moduleBaseUrl).concat(tab.anchor),
    key: "".concat(tab.anchor, "-").concat(tab.label),
    label: tab.label,
    onClick: e => handleClick(e, tab.anchor),
    selected: isTabActive(tab)
  })));
};
svs.arena.shared.components.Menu = Menu;

 })(window);